export default __webpack_public_path__ + "static/bsdex_animation-7f0d0f893fc71186f5f6792f90a7bb01.jpg";